import api from "./api";
import { environnement } from "configs/environnement";
import { IPermissionResponse, ISavePermission } from "models/church.types";

const PermissionService = {
  getAll: () => {
    return api.get<IPermissionResponse[]>(
      `${environnement.baseURL}/permissions`,
    );
  },

  create: (permission: ISavePermission) => {
    return api.post<IPermissionResponse>(
      `${environnement.baseURL}/permissions`,
      permission,
    );
  },

  delete: (id: number) => {
    return api.delete(`${environnement.baseURL}/permissions/${id}`);
  },
};

export default PermissionService;
